import { Components, Theme } from "@mui/material";
export const muiInputAdornmentTheme = (
    theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiInputAdornment"> => ({
    MuiInputAdornment: {},
});
